import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import config from '../../package.json';

import Dashboard from '../containers/Dashboard';
import Preview from '../containers/Preview';
import NoMatch from '../containers/NoMatch';
import { Main } from './LayoutContainer';
import { Navigation } from '../components/Navigation/Navigation';
import { PreviewProvider } from '../containers/Preview/context';
function Router() {
  return (
    <Main>
      <BrowserRouter basename={config.publicPath}>
        <PreviewProvider>
          <Navigation />
          <Routes>
            <Route path="/" element={<Dashboard />}></Route>
            <Route path=":source/pdf">
              <Route path=":id" element={<Preview />} />
            </Route>
            <Route path="pdf">
              <Route path=":id" element={<Preview />} />
            </Route>
            <Route path="*" element={<NoMatch />} />
          </Routes>
        </PreviewProvider>
      </BrowserRouter>
    </Main>
  );
}

export default Router;
